import type { ReactNode } from 'react'
import styles from './PageIntro.module.css'

export interface PageIntroProps {
  title: string
  /**
   * What the page is for.
   */
  children: ReactNode
}

/**
 * The heading of an editor page.
 */
export function PageIntro({ title, children }: PageIntroProps) {
  return (
    <div className={styles.root}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{children}</p>
    </div>
  )
}
